import { ICON_MAPPING } from './icons'
import * as battery0 from '@/../images/icons/tecget/battery0.svg'
import * as battery20 from '@/../images/icons/tecget/battery20.svg'
import * as battery40 from '@/../images/icons/tecget/battery40.svg'
import * as battery60 from '@/../images/icons/tecget/battery60.svg'
import * as battery80 from '@/../images/icons/tecget/battery80.svg'
import * as battery100 from '@/../images/icons/tecget/battery100.svg'
import * as chp from '@/../images/icons/tecget/chp.svg'
import * as container from '@/../images/icons/tecget/container.svg'
import * as containerAlarm from '@/../images/icons/tecget/container_alarm.svg'
import * as containerOk from '@/../images/icons/tecget/container_ok.svg'
import * as containerWarning from '@/../images/icons/tecget/container_warning.svg'
import * as dashboardCenterIcon from '@/../images/icons/tecget/dashboard_center_icon.svg'
import * as wallbox from '@/../images/icons/tecget/wallbox.svg'
import * as wallboxPlugged from '@/../images/icons/tecget/wallbox_plugged.svg'
import * as wallboxUnplugged from '@/../images/icons/tecget/wallbox_unplugged.svg'
import * as wallboxWarning from '@/../images/icons/tecget/wallbox_warning.svg'
import * as fuelcell from '@/../images/icons/tecget/fuelcell.svg'
import * as generic from '@/../images/icons/tecget/generic.svg'
import * as grid from '@/../images/icons/tecget/grid.svg'
import * as heatingelement from '@/../images/icons/tecget/heatingelement.svg'
import * as heatpump from '@/../images/icons/tecget/heatpump.svg'
import * as pv from '@/../images/icons/tecget/pv.svg'
import * as rest from '@/../images/icons/tecget/rest.svg'
import * as trafo from '@/../images/icons/tecget/trafo.svg'
import * as user from '@/../images/icons/tecget/user.svg'

const map = {
  battery: battery0,
  battery0,
  battery20,
  battery40,
  battery60,
  battery80,
  battery100,
  chp,
  container,
  containerAlarm,
  containerOk,
  containerWarning,
  dashboardCenterIcon,
  fuelcell,
  generic,
  grid,
  heatingelement,
  heatpump,
  pv,
  rest,
  trafo,
  user,
  wallbox,
  wallboxPlugged,
  wallboxUnplugged,
  wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}
